import services from 'services/module';
import { HttpSvcFactory } from 'services/HttpSvc';

export class TranscribeSvc {
    constructor(private HttpSvc: HttpSvcFactory) {}

    getTranscribeStats() {
        return this.HttpSvc<anm.UserStats>('profile/stats/transcribe').secureGet();
    }
}

services.service('transcribeSvc', TranscribeSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/TranscribeSvc.ts